import React from "react";

const CommentReader = () => {
  return <div>CommentReader</div>;
};

export default CommentReader;
